// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-column-title-with-tooltip-tableColumnTitleWithTooltip-69417{align-items:center;display:flex}.table-column-title-with-tooltip-tableColumnTitleWithTooltip-69417 .table-column-title-with-tooltip-tooltipIcon-ee393{margin-left:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableColumnTitleWithTooltip": "table-column-title-with-tooltip-tableColumnTitleWithTooltip-69417",
	"tooltipIcon": "table-column-title-with-tooltip-tooltipIcon-ee393"
};
export default ___CSS_LOADER_EXPORT___;
